import { ROUTES } from "@/config/routes";
import CommonLayout from "@/containers/app/CommonLayout";
import { Tabs } from "@chakra-ui/react";
import { Navigate, useSearchParams } from "react-router-dom";
import ClaimsTab from "./claims/ClaimsTab";
import ContractsTab from "./contracts/ContractsTab";
import KeyDatesTab from "./keyDates/KeyDatesTab";
import ScreeningsTab from "./screenings/ScreeningsTab";
import { ProtectNavigation, isProtectTab } from "./types";
import { useProtectMerchant } from "./useProtectMerchant";

const DEFAULT_TAB = "estudios";

const ProtectContainer = (): JSX.Element | null => {
  const { protectMerchant, isLoading } = useProtectMerchant();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") ?? DEFAULT_TAB;

  if (isLoading) return null;
  if (!protectMerchant) return <Navigate to={ROUTES.DASHBOARD.HOME} replace />;

  const navigate = ({ tab, claimsTab }: ProtectNavigation) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("tab", tab);
        if (claimsTab) next.set("claimsTab", claimsTab);
        return next;
      },
      { replace: true }
    );
  };

  const handleTabChange = (value: string) => {
    if (isProtectTab(value)) navigate({ tab: value });
  };

  const table = (
    <Tabs.Root
      value={activeTab}
      onValueChange={(e) => handleTabChange(e.value)}
      variant="line"
      colorPalette="palomma"
      display="flex"
      flexDirection="column"
      flex="1"
      minH={0}
    >
      <Tabs.List bg="transparent" mb={4} flexShrink={0}>
        <Tabs.Trigger
          value="estudios"
          data-tour="protect-tab-estudios"
          fontWeight="medium"
          pb={3}
        >
          Estudios
        </Tabs.Trigger>
        <Tabs.Trigger
          value="contratos"
          data-tour="protect-tab-contratos"
          fontWeight="medium"
          pb={3}
        >
          Contratos
        </Tabs.Trigger>
        <Tabs.Trigger
          value="reclamaciones"
          data-tour="protect-tab-reclamaciones"
          fontWeight="medium"
          pb={3}
        >
          Reclamaciones
        </Tabs.Trigger>
        <Tabs.Trigger
          value="fechasClave"
          data-tour="protect-tab-fechas-clave"
          fontWeight="medium"
          pb={3}
        >
          Fechas clave
        </Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content
        value="estudios"
        display="flex"
        flexDirection="column"
        flex="1"
        minH={0}
        css={{ "&[hidden]": { display: "none" } }}
      >
        <ScreeningsTab />
      </Tabs.Content>
      <Tabs.Content
        value="contratos"
        display="flex"
        flexDirection="column"
        flex="1"
        minH={0}
        css={{ "&[hidden]": { display: "none" } }}
      >
        <ContractsTab />
      </Tabs.Content>
      <Tabs.Content
        value="reclamaciones"
        display="flex"
        flexDirection="column"
        flex="1"
        minH={0}
        css={{ "&[hidden]": { display: "none" } }}
      >
        <ClaimsTab />
      </Tabs.Content>
      <Tabs.Content
        value="fechasClave"
        display="flex"
        flexDirection="column"
        flex="1"
        minH={0}
        css={{ "&[hidden]": { display: "none" } }}
      >
        <KeyDatesTab onNavigate={navigate} />
      </Tabs.Content>
    </Tabs.Root>
  );

  return (
    <CommonLayout
      title="Protect"
      subtitle="Tu fianza de arrendamiento, dentro de Pay."
      table={table}
    />
  );
};

export default ProtectContainer;
